import { ServerLoggerService } from '~shared/modules/server-logger/services/server-logger.service';
import { Injectable } from '@angular/core';
import isEmpty from 'lodash.isempty';

@Injectable({
  providedIn: 'root',
})
export class TierOneFormValidationService {
  constructor(private serverLoggerService: ServerLoggerService) {}

  logTierOneFormValidationError(message, email) {
    const includesEmail = message.includes('email');

    if (includesEmail) {
      const emailAnonymized = !isEmpty(email.email) ? email.email.replace(/[a-zA-Z]/gi, '*').replace(/\d/gi, '#') : '';
      const data = { email: emailAnonymized };
      this.serverLoggerService.error('TIER1 FORM VALIDATION', {
        message,
        data,
      });
    }
  }
}
